import api from "@/api/api";
import { IAccountInfo } from "@/models/account";
import { MutationTree } from "vuex";
import { State } from "./state";
import Cookies from "js-cookie";

export enum AuthMutationTypes {
  SET_TOKEN = "SET_TOKEN",
  SET_INFO = "SET_INFO",
  CLEAR_TOKEN = "CLEAR_TOKEN",
}

export type Mutations<S = State> = {
  [AuthMutationTypes.SET_TOKEN](state: S, data: string): void;
  [AuthMutationTypes.SET_INFO](state: S, data: IAccountInfo | string): void;
  [AuthMutationTypes.CLEAR_TOKEN](state: S): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [AuthMutationTypes.SET_TOKEN](state, token: string) {
    state.token = token;
    localStorage.setItem("access", token);

    Cookies.set("refresh_token", token, { expires: 1, sameSite: "none", secure: true });

    if (token && token.length > 0) {
      api.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  },

  [AuthMutationTypes.SET_INFO](state, data: IAccountInfo) {
    //console.log('AuthMutationTypes.SET_INFO', ResultData);
    state.uid = data.UserId;
    state.userName = data.UserName;
    state.role = data.RoleName;
    state.name = data.Name;
    state.pid = data.PID ? data.PID : "";
    state.isRRN = data.IsRRN;
  },
  [AuthMutationTypes.CLEAR_TOKEN](state) {
    console.trace("AuthMutationTypes.CLEAR_TOKEN", state);
    (state.token = ""), (state.uid = "");
    state.userName = "";
    state.role = "";
    state.name = "";
    state.pid = "";
    localStorage.removeItem("access");
    api.defaults.headers.common.Authorization = "";

    Cookies.set("refresh_token", "");
  },
};
